// utils/randomString.js
export function isFutureDate(dateStr) {
    // Parsing the string as YYYY-MM-DD
    const inputDate = new Date(dateStr);
    const today = new Date();

    // Normalize today to the start of the day (midnight)
    today.setHours(0, 0, 0, 0);

    // Normalize the inputDate just in case time data exists
    inputDate.setHours(0, 0, 0, 0);

    // Returns true only if inputDate is strictly after today
    return inputDate > today;
}